export const GET_LOAD_TREE = "GET_LOAD_TREE";
export const GET_FILTER_TREE = "GET_FILTER_TREE";
export const CLEAR_FILTER_TREE = "CLEAR_FILTER_TREE";
export const SET_FILTER_TREE = "SET_FILTER_TREE";
export const SET_SETTINGS_TREE = "SET_SETTINGS_TREE";
export const SET_CATEGORY_FILTERED_TREE = "SET_CATEGORY_FILTERED_TREE";


